module.exports = __webpack_public_path__ + "UB.svg?5399c1eea545e6f6a4a36d1c8f397726";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/UB.svg
// module id = 71
// module chunks = 0